<template>
    <div class="status-dialogs-order-details">
        <div class="status-dialogs-order-details__slogan">
            {{ getStatus(order) }}
        </div>
        <div class="status-dialogs-order-details__icon">
            <img :src="`static/statuses-new/sets/${getStatusImg(order)}.png`" />
        </div>
        <div class="status-dialogs-order-details__info" :style="{ background: getDescriptionColor(order) }">
            <div class="status-dialogs-order-details__info__icon">
                <img src="static/statuses-new/info.svg" />
            </div>
            <div class="status-dialogs-order-details__info__text">
                <span v-if="order.status === ORDER_STATUS.MEETING_POINT">
                    {{ paidWaitingFree ? 'До конца бесплатного ожидания: ' : 'Время платного ожидания:' }}
                    <b>{{ paidWaitingTimer }}</b>
                </span>
                <span v-else v-html="getDescription(order)"></span>
            </div>
        </div>
        <div class="status-dialogs-order-details__order">
            <div class="status-dialogs-order-details__order__title">Детали заказа</div>
            <div class="status-dialogs-order-details__separate"></div>
            <div class="status-dialogs-order-details__order__content">
                <div class="status-dialogs-order-details__order__content__item">
                    <div class="status-dialogs-order-details__order__content__item__title">Сумма</div>
                    <div class="status-dialogs-order-details__order__content__item__value">{{ getOrderPrice() }}</div>
                </div>
            </div>
            <div class="status-dialogs-order-details__order__content">
                <div class="status-dialogs-order-details__order__content__item">
                    <div class="status-dialogs-order-details__order__content__item__title">Номер заказа</div>
                    <div class="status-dialogs-order-details__order__content__item__value">
                        <div class="status-dialogs-order-details__order__content__item__value__id">
                            {{ order.id }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="status-dialogs-order-details__order__content">
                <div class="status-dialogs-order-details__order__content__item">
                    <div class="status-dialogs-order-details__order__content__item__title">Заказ из</div>
                    <div class="status-dialogs-order-details__order__content__item__value">{{ getEntity() }}</div>
                </div>
            </div>
            <div class="status-dialogs-order-details__order__content">
                <div class="status-dialogs-order-details__order__content__item">
                    <div class="status-dialogs-order-details__order__content__item__title">Адрес доставки</div>
                    <div class="status-dialogs-order-details__order__content__item__value">{{ delivery_address }}</div>
                </div>
            </div>
            <div class="status-dialogs-order-details__order__content">
                <div class="status-dialogs-order-details__order__content__item">
                    <div class="status-dialogs-order-details__order__content__item__title">Способ доставки</div>
                    <div class="status-dialogs-order-details__order__content__item__value">
                        {{ DELIVERY_TYPE_TITLE[order.delivery_type] }}
                        <div class="status-dialogs-order-details__order__content__item__value__price">
                            {{ order.delivery_price > 0 ? order.delivery_price + ' Р' : 'бесплатно' }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="status-dialogs-order-details__order__link" @click="openOrder()">
            <div class="status-dialogs-order-details__order__link__text">
                <div class="status-dialogs-order-details__order__link__icon">?</div>
                Что в заказе?
            </div>
            <div class="status-dialogs-order-details__order__link__arrow">
                <img src="static/statuses-new/arrow-right.svg" />
            </div>
        </div>
        <div v-if="
            !processingPayment(order) &&
            (
                (isPostpayment(order) && order.status === ORDER_STATUS.PREPARED) ||
                (!isPostpayment(order) && order.status === ORDER_STATUS.SUBMITTED)
            )">
            <button
                class="status-dialogs-order-details__pay-button"
                @click="payOrder(order)">
                <span>Оплатить заказ</span>
            </button>
        </div>
        <div v-if="this.getStatusImg(order) === 'done'">
            <div class="status-dialogs-order-details__rate__title">
                Оцените работу нашей команды
            </div>
            <div class="status-dialogs-order-details__rate">
                <button
                    v-for="index in 5"
                    :key="index"
                    @click.stop="updateRating(index)"
                >
                    <img src="static/statuses-new/review/star_active.svg" v-if="rating >= index" />
                    <img src="static/statuses-new/review/star.svg" v-else />
                </button>
            </div>
        </div>
    </div>
</template>


<script>
    import moment from '../../plugins/moment';
    import store from '../../store';
    import { mapState } from 'vuex';
    import { DELIVERY_TYPE, DELIVERY_TYPE_TITLE, ORDER_STATUS, ORDER_PAYMENT_STATUS, PAYMENT_TYPE } from '@/js/utils/vars';

    export default {
        name: 'StatusDialogOrderCard',

        props: {
            order: {
                type: Object,
                default: {},
            },
        },
        
        data: () => ({
            ORDER_STATUS,
            DELIVERY_TYPE_TITLE,
            shown: false,
            intervalId: null,
            freeSeconds: 195 * 60,
            paidWaitingFree: true,
            paidWaitingTimer: '',
            rating: 0,
        }),

        computed: {
            ...mapState('auth', {
                user: state => state.user
            }),
            ...mapState('info', ['towers']),

            delivery_address() {
                return this.order.id
                    ? (this.order.address
                        ? this.order.tower
                            ? this.towers.filter(tower => {
                                return tower.id === this.order.tower;
                            })[0].name
                            : this.order.address.street +
                                ' дом ' +
                                this.order.address.building
                        : '') +
                        (this.order.delivery_type !== DELIVERY_TYPE.MEETING_POINT
                            ? this.order.address_details
                                ? `, под/корп ${this.order.address_details.entrance}, этаж ${this.order.address_details.floor}, кв/оф ${this.order.address_details.appartment}`
                                : ''
                            : ', точка встречи')
                    : '';
            },
        },

        created() {
            this.startTimer();
        },
        destroyed() {
            clearInterval(this.intervalId);
        },

        methods: {
            startTimer() {
                if (this.intervalId) {
                    clearInterval(this.intervalId);
                }
                this.paidWaitingFetch();
                this.intervalId = setInterval(() => {
                    this.paidWaitingFetch();
                }, 1000);
            },
            paidWaitingFetch() {
                if (this.order.status === ORDER_STATUS.MEETING_POINT) {
                    if (this.order.status === ORDER_STATUS.MEETING_POINT) {
                        const currentTime = moment().unix();
                        const updatedTime = moment(this.order.meeting_point_at).unix();
                        this.paidWaitingFree = currentTime - updatedTime < this.order.waiting_free_seconds;
                        let ms = (currentTime - updatedTime) - this.order.waiting_free_seconds;
                        if (this.paidWaitingFree) {
                            ms = this.order.waiting_free_seconds - (currentTime - updatedTime);
                        }
                        if(Math.floor(ms / 60) > 10) {
                            this.paidWaitingTimer = `${Math.floor(ms / 60)}:${('0' + ms % 60).slice(-2)}`;
                        } else {
                            this.paidWaitingTimer = `${('0' + Math.floor(ms / 60)).slice(-2)}:${('0' + ms % 60).slice(-2)}`;
                        }
                    }
                }
            },
            getStatusImg(order) {
                switch (order.status) {
                case ORDER_STATUS.SUBMITTED:
                    if(!this.isPostpayment(order)) {
                        if(this.processingPayment(order)) {
                            return 'payment_in_progress';
                        }
                        return 'not_paid';
                    }
                case ORDER_STATUS.IN_WORK:
                case ORDER_STATUS.ACCEPTED:
                    return 'submitted';
                case ORDER_STATUS.PREPARED:
                    if(this.isPostpayment(order)) {
                        if(this.processingPayment(order)) {
                            return 'payment_in_progress';
                        }
                        return 'not_paid';
                    }
                case ORDER_STATUS.PAID:
                case ORDER_STATUS.AWAITING:
                    return 'awating';
                case ORDER_STATUS.AWAITING_READY:
                    return 'awating_ready';
                case ORDER_STATUS.DELIVERY:
                case ORDER_STATUS.DELIVERY_CONCIERGE:
                    return 'delivery';
                case ORDER_STATUS.MEETING_POINT:
                case ORDER_STATUS.DONE:
                case ORDER_STATUS.PAYMENT_CORRECTION:
                case ORDER_STATUS.DELIVERED_DOOR:
                    return 'done';
                case ORDER_STATUS.CANCELED:
                case ORDER_STATUS.DECLINED:
                    return 'canceled';
                default:
                    return '';
                }
            },

            isPostpayment(order) {
                return order?.partner?.payment === PAYMENT_TYPE.POST_PAYMENT;
            },
            processingPayment(order) {
                return order && order.payments ? order.payments.find(item => item.status === ORDER_PAYMENT_STATUS.PROCESSING) : false
            },
            faildPayment(order) {
                return order && order.payments ? order.payments.find(item => item.status === ORDER_PAYMENT_STATUS.FAIL || item.status === ORDER_PAYMENT_STATUS.CANCELED) : false
            },
            getStatus(order) {
                switch (order.status) {
                case ORDER_STATUS.SUBMITTED:
                    if(!this.isPostpayment(order)) {
                        if(this.processingPayment(order)) {
                            return 'Платеж в обработке';
                        }
                        if(this.faildPayment(order)) {
                            return 'Оплата не прошла';
                        }
                        return 'Заказ не оплачен';
                    }
                case ORDER_STATUS.IN_WORK:
                case ORDER_STATUS.ACCEPTED:
                    return 'Ваш заказ получен';
                case ORDER_STATUS.PREPARED:
                    if(this.isPostpayment(order)) {
                        if(this.processingPayment(order)) {
                            return 'Платеж в обработке';
                        }
                        if(this.faildPayment(order)) {
                            return 'Оплата не прошла';
                        }
                        return 'Заказ требует оплаты';
                    }
                case ORDER_STATUS.PAID:
                    if(this.isPostpayment(order)) {
                        return 'Заказ оплачен!';
                    }
                case ORDER_STATUS.AWAITING:
                    return 'Заказ в работе';
                case ORDER_STATUS.AWAITING_READY:
                    return 'Заказ готов, курьер в пути';
                case ORDER_STATUS.DELIVERY:
                    return 'Заказ готов, курьер в пути';
                case ORDER_STATUS.DELIVERY_CONCIERGE:
                    return 'Заказ у консьержа!';
                case ORDER_STATUS.MEETING_POINT:
                    return 'Заказ доставлен!';
                case ORDER_STATUS.DONE:
                case ORDER_STATUS.PAYMENT_CORRECTION:
                case ORDER_STATUS.DELIVERED_DOOR:
                    return 'Заказ выполнен!';
                case ORDER_STATUS.CANCELED:
                case ORDER_STATUS.DECLINED:
                    return 'Заказ отменен!';
                default:
                    return '';
                }
            },

            getDescriptionColor(order) {
                switch (order.status) {
                case ORDER_STATUS.SUBMITTED:
                case ORDER_STATUS.IN_WORK:
                case ORDER_STATUS.ACCEPTED:
                case ORDER_STATUS.PAID:
                case ORDER_STATUS.AWAITING:
                case ORDER_STATUS.PREPARED:
                case ORDER_STATUS.AWAITING_READY:
                case ORDER_STATUS.DELIVERY:
                case ORDER_STATUS.DELIVERY_CONCIERGE:
                case ORDER_STATUS.MEETING_POINT:
                case ORDER_STATUS.DONE:
                case ORDER_STATUS.PAYMENT_CORRECTION:
                case ORDER_STATUS.DELIVERED_DOOR:
                    return '#F4F4F4';
                case ORDER_STATUS.CANCELED:
                case ORDER_STATUS.DECLINED:
                    return '#FFE6E6';
                default:
                    return '';
                }
            },
            getDescription(order) {
                switch (order.status) {
                case ORDER_STATUS.SUBMITTED:
                    if(!this.isPostpayment(order)) {
                        if(this.processingPayment(order)) {
                            return 'Платеж обрабатывается, это может занять несколько минут';
                        }
                        if(this.faildPayment(order)) {
                            return 'Проверьте интернет - соединение или попробуйте другую карту';
                        }
                        return 'Для начала выполнения заказа, пожалуйста, оплатите его';
                    }
                case ORDER_STATUS.IN_WORK:
                case ORDER_STATUS.ACCEPTED:
                    return `Мы получили ваш заказ и ждем подтверждения от партнера`;
                case ORDER_STATUS.PREPARED:
                    if(this.isPostpayment(order)) {
                        return `Заказ подтвержден в ${ this.getEntity() }. Для начала работы заказ должен быть оплачен`;
                    }
                case ORDER_STATUS.PAID:
                case ORDER_STATUS.AWAITING:
                    return `Заказ готовится. Мы назначаем курьера`;
                case ORDER_STATUS.AWAITING_READY:
                    return `Заказ готов. Мы уже отправили курьера за заказом.`;
                case ORDER_STATUS.DELIVERY:
                    return `Курьер взял заказ и едет по адресу`;
                case ORDER_STATUS.DELIVERY_CONCIERGE:
                    return `Консьерж взял заказ и уже идет к вам. Вы скоро получите свой заказ. Ожидайте пожалуйста`;
                case ORDER_STATUS.MEETING_POINT:
                    return '';
                case ORDER_STATUS.DONE:
                case ORDER_STATUS.PAYMENT_CORRECTION:
                case ORDER_STATUS.DELIVERED_DOOR:
                    return `Заказ выполнен!<br>Спасибо за заказ! Ожидаем вас снова!`;
                case ORDER_STATUS.CANCELED:
                case ORDER_STATUS.DECLINED:
                    return `Заказ отменен!<br>Свяжитесь пожалуйста с поддержкой!`;
                default:
                    return '';
                }
            },
            getEntity() {
                return this.order.rd?.items[0]?.restaurant.title
                    || this.order.gd?.items[0]?.grocer.title
                    || this.order.ed?.items[0]?.entity.title;
            },
            openOrder() {
                const orderId = this.order.id;
                this.$emit('sheet-close');
                this.$f7.views[0].router.navigate({
                    name: 'orders-detail',
                    params: {
                        orderId
                    }
                });
            },
            payOrder(order) {
                this.$emit('sheet-close');
                this.$f7.views[0].router.navigate({
                    name: 'payment',
                    params: {
                        orderType: order.type,
                        orderId: order.id
                    },
                });
            },
            getOrderPrice() {
                const total = +this.order.price + +this.order.delivery_price + +this.order.waiting_price + (+this.order.service_fee || 0);
                return `${
                    ((total ^ 0) === total)
                        ? total
                        : total.toFixed(2)
                } Р`
            },
            async updateRating(rating) {
                this.$emit('rating-updated', rating);
                const review = {
                    order_id: this.order.id,
                    rating: rating,
                    finished: false,
                }
                await store.dispatch('orders/sendReview', { review });
            },
        }
    };
</script>

<style lang="scss">
.status-dialogs-order-details {
    padding: 2px 8px;

    &__separate {
        height: 1px;
        background-color: #F4F4F4;
        margin: 12px 0 16px 0;
    }

    &__slogan {
        margin-top: 12px;
        font-weight: 600;
        font-size: 26px;
        line-height: 100%;
        text-align: center;
        color: #232321;
    }
    &__icon {
        margin-top: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
            height: 43px;
        }
    }
    &__info {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 10px;
        border-radius: 10px;
        background: #F4F4F4;
        margin-top: 24px;

        &__icon {
            width: 16px;
            height: 16px;
            margin-right: 8px;
            
            img {
                width: 16px;
                max-width: 16px;
            }
        }
        &__text {
            font-weight: 400;
            font-size: 12px;
            line-height: 130%;
            color: #232321;
        }
    }
    &__order {
        margin-top: 32px;

        &__title {
            font-weight: 500;
            font-size: 16px;
            line-height: 110%;
            color: #232321;
        }
        &__content {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;

            &__item {
                width: 100%;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: flex-start;
                padding: 0 4px;
                margin-bottom: 10px;

                &__title {
                    font-weight: 500;
                    font-size: 12px;
                    line-height: 110%;
                    color: #232321;
                    min-width: 140px;
                }
                &__value {
                    text-align: right;
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 110%;
                    color: #232321;

                    &__id {
                        font-weight: 600;
                        margin: 0 -4px;
                        padding: 4px 8px;
                        border-radius: 90px;
                        background: #F4F4F4;
                    }
                    
                    &__price {
                        font-weight: 400;
                        font-size: 12px;
                        line-height: 110%;
                        color: #1976D2;
                    }
                }
            }
        }

        &__link {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 10px;

            &__icon {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 16px;
                height: 16px;
                font-weight: 500;
                font-size: 10px;
                line-height: 120%;
                margin-right: 8px;
                color: #fff;
                background: #1976D2;
                border-radius: 90px;
            }
            &__text {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                font-weight: 500;
                font-size: 12px;
                line-height: 16px;
            }
            &__arrow {
                width: 16px;
                height: 16px;
                img {
                    width: 16px;
                    max-width: 16px;
                }
            }
        }
    }
    &__content {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;

        &__inline {
            display: flex;
            align-items: flex-start;
        }
        &__id {
            font-weight: 600;
            font-size: 12px;
            line-height: 100%;
            text-align: center;
            color: #232321;
            border: 1px solid #9FA8B1;
            padding: 4px 8px;
            border-radius: 90px;
        }
        &__slogan {
            margin-top: 8px;
            font-weight: 500;
            font-size: 14px;
            line-height: 100%;
            color: #232321;
        }
        &__entity {
            margin-top: 8px;
            font-weight: 400;
            font-size: 12px;
            line-height: 100%;
            color: #232321;
        }
        &__timer {
            font-weight: 600;
            font-size: 12px;
            line-height: 100%;
            text-align: center;
            padding: 6px 10px;
            border-radius: 90px;
            background: #F4F4F4;

        }
    }
    &__pay-button {
        width: 100%;
        height: 49px;
        border-radius: 90px;
        background: #1F3A60;
        font-weight: 500;
        font-size: 14px;
        line-height: 120%;
        text-align: center;
        color: #fff;
        margin-top: 24px;
    }
    &__rate {
        flex: 1 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        max-width: 277px;
        margin: 0 auto;

        &__title {
            font-weight: 400;
            font-size: 13px;
            line-height: 100%;
            text-align: center;
            color: #7D7D7D;
            margin-top: 24px;
            margin-bottom: 20px;
        }

        button {
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}
</style>
